import { render, staticRenderFns } from "./Pendding.vue?vue&type=template&id=64bd155c&"
import script from "./Pendding.vue?vue&type=script&lang=js&"
export * from "./Pendding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports